import { OperatorSalesCommissionPage } from "@/components/non_registrant/operator-sales-commission";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/overview_/sales-commission/")({
  component: OperatorSalesCommissionPage,
});
